import { buildProps } from '@lit-element/utils'
import { Ecc } from './qrcodegen'
import type { ExtractPropTypes, PropType } from 'vue'
import type Qrcode from './qrcode.vue'

// 定义类型
export const LEVEL_MAP = {
  L: Ecc.LOW,
  M: Ecc.MEDIUM,
  Q: Ecc.QUARTILE,
  H: Ecc.HIGH,
}
export type LEVEL_MAP_TYPE = typeof LEVEL_MAP

export type ImageSettings = {
  src?: string
  width?: number
  height?: number
  x?: number
  y?: number
  excavate?: boolean
}

export const qrcodeProps = buildProps({
  /**
   * @description 二维码的值
   */
  value: {
    type: String,
    required: true,
    default: '',
  },
  /**
   * @description 二维码的大小
   */
  size: {
    type: Number,
    default: 100,
  },
  /**
   * @description 二维码的纠错级别
   */
  level: {
    type: String as PropType<keyof LEVEL_MAP_TYPE>,
    default: 'L',
  },
  /**
   * @description 二维码的背景颜色
   */
  background: {
    type: String,
    default: '#fff',
  },
  /**
   * @description 二维码的前景颜色
   */
  foreground: {
    type: String,
    default: '#000',
  },
  /**
   * @description 二维码的边距
   */
  margin: {
    type: Number,
    required: false,
    default: 0,
  },
  /**
   * @description 图片设置
   */
  imageSettings: {
    type: Object as PropType<ImageSettings>,
    required: false,
    default: () => ({} as ImageSettings),
  },
} as const)

export type QrcodeProps = ExtractPropTypes<typeof qrcodeProps>
export type QrcodeInstance = InstanceType<typeof Qrcode>
